import React, { useState } from 'react';
import { FiEye, FiEyeOff, FiArrowLeft } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications'

import { login } from '../../auth/auth';
import api from '../../services/api';

import logo from '../../assets/fullLogo.png';
import './styles.css';

function CreateUser() {
    const { addToast } = useToasts()
    const [name, setName] = useState('');
    const [miaw, setMiaw] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [inputPassword, setInputPassword] = useState('password');

    const history = useHistory();

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        await api.post('users', {
            name,
            miaw,
            email,
            password,
            confirm_password: confirmPassword
        }).then(response => {
            addToast('Bem-vindo(a) à plataforma Miaw', {
                appearance: 'success',
                autoDismiss: true,
            })
            api.post('login', { email, password }).then(response => {
                login(response.data.token, response.data.currentUser);
                history.push('/list/story');
            }).catch(e => {
                addToast(e.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                })
            });
        }).catch(e => {
            addToast(e.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
            })
        })
    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136} />
                <nav id="menu">
                    <Link to="/">
                        <FiArrowLeft />
                        Voltar para home
                    </Link>
                </nav>
            </header>
            <form onSubmit={handleSubmit}>
                <h1>Cadastro de usuário</h1>
                <fieldset>
                    <legend>
                        <h2>Informe seus dados</h2>
                    </legend>
                    <div className="field">
                        <label htmlFor="name">
                            Seu nome
                        </label>
                        <input
                            type="text"
                            placeholder="Digite seu nome..."
                            id="name"
                            value={name}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="miaw">
                            Nome do Miaw
                        </label>
                        <input
                            type="text"
                            placeholder="Digite o nome do Miaw..."
                            id="miaw"
                            value={miaw}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMiaw(e.currentTarget.value)}
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="email">
                            Seu email
                        </label>
                        <input
                            type="text"
                            placeholder="Digite seu email..."
                            id="email"
                            value={email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.currentTarget.value)}
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="password">
                            Informe uma senha
                        </label>
                        <div>
                            <input
                                type={inputPassword}
                                placeholder="Digite sua senha..."
                                id="password"
                                value={password}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)}
                                style={{
                                    marginRight: 8,
                                    width: '95%'
                                }}
                            />
                            {inputPassword === 'password' ? (
                                <i style={{
                                    cursor: 'pointer',
                                    width: '5%'
                                }} onClick={() => setInputPassword('text')}
                                ><FiEye /></i>
                            ) : (
                                    <i style={{
                                        cursor: 'pointer',
                                        width: '5%'
                                    }} onClick={() => setInputPassword('password')}><FiEyeOff /></i>
                                )}
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="password">
                            Confirme a senha
                        </label>
                        <input
                            type="password"
                            placeholder="Digite a confirmação de senha..."
                            id="password-confirmation"
                            value={confirmPassword}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.currentTarget.value)}
                        />
                    </div>
                </fieldset>
                <button type="submit">Salvar</button>
            </form>
        </div>
    );
}

export default CreateUser;
